import { render, staticRenderFns } from "./MypageEcSiteConnectErrorParts.vue?vue&type=template&id=bd87c148&scoped=true"
import script from "./MypageEcSiteConnectErrorParts.vue?vue&type=script&lang=ts"
export * from "./MypageEcSiteConnectErrorParts.vue?vue&type=script&lang=ts"
import style0 from "./MypageEcSiteConnectErrorParts.vue?vue&type=style&index=0&id=bd87c148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd87c148",
  null
  
)

export default component.exports